(function () {
    'use strict';

    var serviceId = 'endeksService';

    angular.module('app.core').factory(serviceId, endeksService);

    endeksService.$inject = ['$q', 'notifierSvc', 'yandexGeocode', 'mapOptionsService', 'valuationGETAPI', "valuationPOSTAPI", 'userSvc', '$interval', '$rootScope', '$compile', 'CacheFactory', '$timeout', 'guardSvc', '$translate',
        'ngDialog'
    ];

    function endeksService($q, notifierSvc, yandexGeocode, mapOptionsService, valuationGETAPI, valuationPOSTAPI, userSvc, $interval, $rootScope, $compile, CacheFactory, $timeout, guardSvc, $translate,
        ngDialog
    ) {
        var service = {
            EndeksList: [],
            EndeksDetail: {},
            Valuations: {},
            cachedLimits: null,
            checkLimits: checkLimits,
            loadEndeksDetail: loadEndeksDetail,
            deleteEndeks: deleteEndeks,
            loadValuations: loadValuations,
            loadComparables: loadComparables,
            makeValuation: makeValuation,
            reValuate: reValuate,
            loadHistory: loadHistory,
            selectValuation: selectValuation,
            changeName: changeName,
            changeNote: changeNote,
            getNote: getNote,
            changeFiles: changeFiles,
            getFiles: getFiles,
            changeState: changeState,
            getAutoValuationInfo: getAutoValuationInfo,
            createAutoValuationInfo: createAutoValuationInfo,
            deleteAutoValuationInfo: deleteAutoValuationInfo,

            setDetailMarker: setDetailMarker,
            listOlanak: listOlanak,
            listManzara: listManzara,
            listManzaraArsa: listManzaraArsa,
            listOlanakArsa: listOlanakArsa,
            listManzaraTicari: listManzaraTicari,
            listOlanakTicari: listOlanakTicari,
            listReklamTicari: listReklamTicari,
            // listReportStatus: listReportStatus,
            fetchData: fetchData,
            listCephe: listCephe,
            listTasinmazTipi: listTasinmazTipi,
            listArsaTipi: listArsaTipi,
            listAraziTipi: listAraziTipi,
            listDaireTipi: listDaireTipi,
            listTicariTipi: listTicariTipi,
            listIsinmaDurumu: listIsinmaDurumu,
            listIsinmaDurumuTicari: listIsinmaDurumuTicari,
            listEnrgCertType: listEnrgCertType,
            listUsageStatus: listUsageStatus,
            listStructureCondition: listStructureCondition,

            listTicariTipiLight: listTicariTipiLight,
            listTicariTipiSelectionTemp: listTicariTipiSelectionTemp,


            listRoad: listRoad,
            listSea: listSea,

            listAltTipi: listAltTipi,
            listTicariKonumTipi: listTicariKonumTipi,
            listTicariKotFarkiTipi: listTicariKotFarkiTipi,
            listKatTipi: listKatTipi,
            listYapininDurumu: listYapininDurumu,


            listTicariBinaTipi: listTicariBinaTipi,
            listeEndustriTipi: listeEndustriTipi,
            listTicariOfisTipi: listTicariOfisTipi,


            listUrun: listUrun,
            listEgim: listEgim,
            listOlanakTarla: listOlanakTarla,

            resolveAddress: resolveAddress,
            setTempEndeks: setTempEndeks,
            retrieveTempEndeks: retrieveTempEndeks,
            clearTempEndeks: clearTempEndeks,
            originalEndeks: {
                Id: null,
                OnlyValuation: false,
                Address: "",
                Age: null,
                FloorCount: null,
                FloorNumber: null,
                Latitude: null,
                Longitude: null,
                Name: null,
                Room: null,
                LivingRoom: 1,
                BathRoom: 1,
                Type: 10,
                Area: null,
                ExtraArea: null,
                Possibilities: [],
                Faces: [],
                Views: [],
                HeatType: null,
                tempFaces: {},
                tempViews: [],
                tempApartmentTypes: [],
                tempPossibilities: {},
                AdsCapabilities: null,
                tempHeatTypes: [],
                UsageStatus: 30,
                StructureCondition: 20
            },
            tempEndeks: {
                Id: null,
                OnlyValuation: false,
                Address: "",
                Age: null,
                FloorCount: null,
                FloorNumber: null,
                Latitude: null,
                Longitude: null,
                Name: null,
                Room: null,
                LivingRoom: null,
                BathRoom: null,
                Type: null,
                Area: null,
                ExtraArea: null,
                Possibilities: [],
                Faces: [],
                Views: [],
                HeatType: null,
                tempFaces: {},
                tempViews: [],
                tempApartmentTypes: [],
                tempPossibilities: {},
                AdsCapabilities: null,
                tempHeatTypes: [],
                UsageStatus: 30,
                StructureCondition: 20
            },

            checkIfAvailable: checkIfAvailable,

            // getPublicEndeks: getPublicEndeks,
            toggleInfo: toggleInfo
        };

        return service;

        function checkLimits(fieldType, min, max) {
            return fieldType === null || isNaN(fieldType) || fieldType > max || fieldType < min;
        };
        function checkIfAvailable(lat, lng) {
            var deferred = $q.defer();
            userSvc.getUserInfo().then(function (account) {
                var objData = {
                    DataLevel: 0,
                    UserId: account.information.id.value,
                    OrderBy: 1,
                    Sort: 2,
                    ItemSize: 10,
                    ActivePageNumber: 1,
                    PropertyCategory: 0,
                    PropertyType: 4,
                    Lat: lat,
                    Long: lng,
                    Radius: 20
                };
                var valuation = valuationGETAPI.list(objData);
                valuation.$promise.then(function (response) {
                    if (response.TotalCount)
                        if (!$rootScope.isBank)
                            notifierSvc.show({ message: $translate.instant("revaluate_warning1") + " <a style='text-decoration:underline;font-weight:500' href='https://www.endeksa.com/" + window.lang + "/" + $translate.instant("analysis") + "/l/" + lat.toString().replace('.', ',') + ";" + lng.toString().replace('.', ',') + "/portfolio'>" + $translate.instant("n_myWorkPlace") + "</a> " + $translate.instant("revaluate_warning2"), type: "info", hideDuration: 10000 });
                        else
                            ngDialog.open({
                                templateUrl: 'app/endeks/valuation-exist-modal.html',
                                data: {
                                    lat: lat,
                                    lng: lng,
                                    lang: window.lang
                                }
                            });
                    deferred.resolve(response.TotalCount);
                }, function (err) {
                    deferred.reject(err);
                });
            }, function (err) {
                deferred.reject(err);
            });
            return deferred.promise;
        }


        function loadEndeksDetail(id) {
            var deferred = $q.defer();
            var valuation = valuationGETAPI.details({ propertyid: id });
            valuation.$promise.then(function (response) {
                service.EndeksDetail = response;
                deferred.resolve(service.EndeksDetail);
            }, function (err) {
                deferred.reject(err);
            });

            return deferred.promise;
        }

        function loadValuations(id) {
            var deferred = $q.defer();
            var valuation = valuationGETAPI.get({ propertyid: id });
            valuation.$promise.then(function (response) {
                deferred.resolve(response);
            }, function (err) {
                deferred.reject(err);
            });

            return deferred.promise;
        }

        function getAutoValuationInfo(propertyId) {
            var deferred = $q.defer();
            valuationGETAPI.getAutoValuationInfo({ propertyId: propertyId }).$promise.then(function (result) {
                deferred.resolve(result);
            }, function (err) {
                deferred.reject(err);
            });

            return deferred.promise;
        }

        function createAutoValuationInfo(data) {
            var deferred = $q.defer();
            valuationPOSTAPI.createAutoValuationInfo(data).$promise.then(function (result) {
                deferred.resolve(result);
            }, function (err) {
                deferred.reject(err);
            });

            return deferred.promise;
        }

        function deleteAutoValuationInfo(data) {
            var deferred = $q.defer();
            valuationPOSTAPI.deleteAutoValuationInfo(data).$promise.then(function (result) {
                deferred.resolve(result);
            }, function (err) {
                deferred.reject(err);
            });

            return deferred.promise;
        }

        function loadHistory(id) {
            var deferred = $q.defer();
            var valuation = valuationGETAPI.history({ propertyid: id, history: true });
            valuation.$promise.then(function (response) {
                service.Valuations = response.History;
                deferred.resolve(service.Valuations);
            }, function (err) {
                deferred.reject(err);
            });

            return deferred.promise;
        }

        function selectValuation(id, isSales) {
            var deferred = $q.defer();
            var valuation = valuationGETAPI.select({ valuationid: id, isSales: isSales });
            valuation.$promise.then(function (response) {
                cleanCache();
                deferred.resolve(response);
            }, function (err) {
                deferred.reject(err);
            });

            return deferred.promise;
        }


        function loadComparables(id, property) {
            var deferred = $q.defer();
            var valuation = valuationGETAPI.comparables({ valuationid: id, propertyid: property });
            valuation.$promise.then(function (resp) {
                deferred.resolve(resp.Comparables);
            }, function (err) {
                deferred.reject(err);
            });

            return deferred.promise;
        }

        function deleteEndeks(id) {
            var deferred = $q.defer();
            var valuation = valuationGETAPI.delete({ id: id });
            valuation.$promise.then(function (response) {
                cleanCache();
                deferred.resolve(response);
            }, function (result) {
                if (result.errors)
                    result.errors.map(function (error) {
                        notifierSvc.show({ message: error.Message, type: "error" });
                    });
                else
                    notifierSvc.show({ message: result.error, type: "error" });
                deferred.reject(result);
            });
            return deferred.promise;
        }

        function cleanCache() {
            CacheFactory.get('Valuations') && CacheFactory.get('Valuations').removeAll();
            CacheFactory.get('ValuationsHistory') && CacheFactory.get('ValuationsHistory').removeAll();
            CacheFactory.get('ValuationsThematic') && CacheFactory.get('ValuationsThematic').removeAll();
            CacheFactory.get('ValuationsAssets') && CacheFactory.get('ValuationsAssets').removeAll();

            CacheFactory.get('ValuationsDetail') && CacheFactory.get('ValuationsDetail').removeAll();
            CacheFactory.get('ValuationsInside') && CacheFactory.get('ValuationsInside').removeAll();
            CacheFactory.get('ValuationsComparable') && CacheFactory.get('ValuationsComparable').removeAll();
            CacheFactory.get('ValuationsSimple') && CacheFactory.get('ValuationsSimple').removeAll();

            CacheFactory.get('Agents') && CacheFactory.get('Agents').removeAll();
            CacheFactory.get('AgentsGet') && CacheFactory.get('AgentsGet').removeAll();
            CacheFactory.get('AgentsThematic') && CacheFactory.get('AgentsThematic').removeAll();

            CacheFactory.get('UserCache') && CacheFactory.get('UserCache').removeAll();
            CacheFactory.get('UserInfo') && CacheFactory.get('UserInfo').removeAll();
            CacheFactory.get('UserProducts') && CacheFactory.get('UserProducts').removeAll();
        };

        function makeValuation(data, force, fromDetail = false) {
            var deferred = $q.defer();
            window.valuationCompleted = false;

            guardSvc.hasPackage().then(function (response) {
                if (!response && !force) {
                    $timeout(function () {
                        $rootScope.askMembership(true, fromDetail);
                    }, 1000);
                    window.valuationCompleted = true;
                    deferred.reject();
                }
                else if (!data.CreatorId)
                    userSvc.getUserInfo().then(function (account) {
                        if (account && account.information.id.value) {
                            data.CreatorId = account.information.id.value;
                            var valuation = valuationPOSTAPI.setQueue(data);
                            valuation.$promise.then(function (response) {
                                var try_Count = 20;
                                var intr = $interval(function () {
                                    var que = valuationGETAPI.getQueue({ propertyId: response.PropertyId });
                                    que.$promise.then(function (final) {
                                        try_Count--;
                                        if (final.IsValuated) {
                                            window.valuationCompleted = true;
                                            $interval.cancel(intr);
                                            localStorage.removeItem('Endeks');
                                            clearTempEndeks();
                                            var array = [];
                                            array.push({ PropertyId: final.PropertyId });
                                            cleanCache();
                                            $timeout(function () {
                                                deferred.resolve(array);
                                            }, 500);
                                        }
                                        if (!try_Count) {
                                            $interval.cancel(intr);
                                            cleanCache();
                                            deferred.reject();
                                        }
                                    }, function (err) {
                                        cleanCache();
                                        $interval.cancel(intr);
                                        deferred.reject(err);
                                    });
                                }, 30000);
                            }, function (err) {
                                deferred.reject(err);
                            });
                        }
                        else {
                            deferred.reject();
                        }
                    }, function (err) {
                        deferred.reject(err);
                    });
                else {
                    var valuation = valuationPOSTAPI.setQueue(data);
                    valuation.$promise.then(function (response) {
                        var intr = $interval(function () {
                            var try_Count = 20;
                            var que = valuationGETAPI.getQueue({ propertyId: response.PropertyId });
                            que.$promise.then(function (final) {
                                try_Count--;
                                if (final.IsValuated) {
                                    $interval.cancel(intr);
                                    localStorage.removeItem('Endeks');
                                    clearTempEndeks();
                                    var array = [];
                                    array.push({ PropertyId: final.PropertyId });
                                    cleanCache();
                                    deferred.resolve(array);
                                }
                                if (!try_Count) {
                                    $interval.cancel(intr);
                                    cleanCache();
                                    deferred.reject();
                                }
                            }, function (err) {
                                cleanCache();
                                $interval.cancel(intr);
                                deferred.reject(err);
                            });
                        }, 30000);
                    }, function (err) {
                        deferred.reject(err);
                    });
                }
            });
            return deferred.promise;
        }

        function changeName(id, name) {
            var deferred = $q.defer();
            var valuation = valuationGETAPI.changeName({ propertyid: id, name: name });
            valuation.$promise.then(function (response) {
                cleanCache();
                deferred.resolve(response);
            }, function (err) {
                deferred.reject(err);
            });
            return deferred.promise;
        }

        function changeNote(id, note) {
            var deferred = $q.defer();
            var valuation = valuationPOSTAPI.addNote({ propertyid: id, note: note });
            valuation.$promise.then(function (response) {
                deferred.resolve(response);
            }, function (err) {
                deferred.reject(err);
            });
            return deferred.promise;
        }

        function getNote(id) {
            var deferred = $q.defer();
            var valuation = valuationGETAPI.getNote({ propertyid: id });
            valuation.$promise.then(function (response) {
                deferred.resolve(response);
            }, function (err) {
                deferred.reject(err);
            });
            return deferred.promise;
        }

        function changeState(id, value, date, status, statemenDate, rentStatementValue, salesStatementValue, valuationType) {
            var deferred = $q.defer();
            var valuation = valuationGETAPI.updateState({ propertyid: id, value: value, date: date, status: status, statementDate: statemenDate, rentStatementValue: rentStatementValue, salesStatementValue: salesStatementValue, valuationType: valuationType });
            valuation.$promise.then(function (response) {
                cleanCache();
                deferred.resolve(response);
            }, function (err) {
                deferred.reject(err);
            });
            return deferred.promise;
        }

        function changeFiles(id, files) {
            var deferred = $q.defer();
            var valuation = valuationPOSTAPI.changeFiles({ propertyid: id, files: files });
            valuation.$promise.then(function (response) {
                deferred.resolve(response);
            }, function (err) {
                deferred.reject(err);
            });
            return deferred.promise;
        }

        function getFiles(id) {
            var deferred = $q.defer();
            var valuation = valuationGETAPI.getFiles({ propertyid: id });
            valuation.$promise.then(function (response) {
                deferred.resolve(response);
            }, function (err) {
                deferred.reject(err);
            });
            return deferred.promise;
        }

        function reValuate(id, isAuto, wkt) {
            var data = {
                OnlyValuation: true,
                Id: id,
                IsAuto: isAuto,
                wkt: wkt
            };
            var deferred = $q.defer();
            window.valuationCompleted = false;
            userSvc.getUserInfo(true).then(function (account) {
                if (account && account.information.id.value) {
                    // guardSvc.hasPackage().then(function (response) {
                    //     if (!response) {
                    //         $timeout(function () {
                    //             $rootScope.askMembership(true,true);
                    //         }, 1000);
                    //         window.valuationCompleted = true;
                    //         deferred.reject();
                    //     }
                    //     else {
                    //     }
                    // });
                    var creator = account.information.id.value;
                    data.CreatorId = creator;
                    var valuation = valuationPOSTAPI.set(data);
                    valuation.$promise.then(function (response) {
                        cleanCache();
                        window.valuationCompleted = true;
                        $timeout(function () {
                            deferred.resolve(response);
                        }, 500);
                    }, function (err) {
                        deferred.reject(err);
                    });
                }
            }, function (err) {
                deferred.reject(err);
            });
            return deferred.promise;
        }

        function setTempEndeks(obj) {

            for (var key in obj) {
                service.tempEndeks[key] = obj[key];
            }
            // console.log("set", service.tempEndeks);
            localStorage.setItem('tempEndeks', JSON.stringify(service.tempEndeks));
        }

        function retrieveTempEndeks() {
            var deferred = $q.defer();
            var item = localStorage.getItem('tempEndeks');
            if (!item) {
                localStorage.setItem('tempEndeks', JSON.stringify(service.tempEndeks));
            } else {
                try {
                    service.tempEndeks = JSON.parse(item);
                }
                catch (err) {
                    localStorage.removeItem('tempEndeks');
                }
            }
            // console.log("get", service.tempEndeks);
            deferred.resolve(service.tempEndeks);
            return deferred.promise;
        }

        function clearTempEndeks() {
            service.tempEndeks = angular.copy(service.originalEndeks);
            window.rememberProperty = null;
            localStorage.removeItem('tempEndeks');
        }


        // function listReportStatus() {
        //     appActivitySvc.busy("endeksService");

        //     return endeksClientService.ListReportStatus()
        //         .then(
        //             function (result) {
        //                 //notifierSvc.show({ message: "Cepheler yüklendi" });
        //                 return result;
        //             },
        //             function (result) {
        //                 notifierSvc.show({ message: result.error, type: "error" });
        //                 return $q.reject(result);
        //             })['finally'](
        //                 function () {
        //                     appActivitySvc.idle("endeksService");
        //                 });
        // }


        // function getPublicEndeks(id) {
        //     return $http({
        //         method: 'GET',
        //         url: appSettingsSvc.CACHE + '/tasinmazsimple?propertyid=' + id
        //     }, { ignoreLoadingBar: true }).then(
        //         function (response) {
        //             if (response && response.data && response.data.PropertyDetails) {
        //                 return {
        //                     result: "success",
        //                     data: response.data
        //                 };
        //             } else {
        //                 return $q.reject({
        //                     result: "failure",
        //                     errors: response.data.OperationResult.Errors
        //                 });
        //             }
        //         },
        //         function (result) {
        //             return $q.reject({
        //                 result: "failure",
        //                 error: "Konut yüklenemedi."
        //             });
        //         }
        //     );
        // }

        function listOlanak() {
            return [
                { Name: 'Anayol Üzeri', Id: 10 },
                { Name: 'Cadde Üzeri', Id: 15 },
                { Name: 'Site İçerisinde', Id: 20 },
                { Name: 'Spor Sahası/Salonu', Id: 30 },
                { Name: 'Çocuk Oyun Parkı', Id: 40 },
                { Name: 'Asansör', Id: 50 },
                { Name: 'Jeneratör', Id: 60 },
                { Name: 'Bina/Site Görevlisi', Id: 70 },
                { Name: 'Güvenlik', Id: 80 },
                { Name: 'Otopark', Id: 90 },
                { Name: 'Kapalı Otopark', Id: 100 },
                { Name: 'Havuz', Id: 110 },
                { Name: 'Kapalı Havuz', Id: 120 },
                { Name: 'Isı Yalıtımı', Id: 130 },
                { Name: 'Klima', Id: 150 },
                { Name: 'Şömine', Id: 155 },
                { Name: 'Yeşil Alan', Id: 360 },
                { Name: 'Balkon', Id: 370 }
            ];
        }

        function listManzara() {
            return [
                { Name: 'İstinat Duvarı', Id: 10 },
                { Name: 'Yan Bina', Id: 20 },
                { Name: 'Cadde/Sokak', Id: 30 },
                { Name: 'Bahçe', Id: 40 },
                { Name: 'Şehir', Id: 50 },
                { Name: 'Doğa', Id: 60 },
                { Name: 'Göl', Id: 70 },
                { Name: 'Deniz', Id: 80 },
                { Name: 'Boğaz', Id: 90 }
            ];
        }

        function listEnrgCertType() {
            return [
                { Name: 'A+', Id: 9 },
                { Name: 'A', Id: 1 },
                { Name: 'B', Id: 2 },
                { Name: 'B-', Id: 10 },
                { Name: 'C', Id: 3 },
                { Name: 'D', Id: 4 },
                { Name: 'E', Id: 5 },
                { Name: 'F', Id: 6 },
                { Name: 'G', Id: 7 },
                { Name: 'In Process', Id: 11 },
                { Name: 'Exempt', Id: 8 },
                { Name: 'Unknown', Id: -1 }
            ];
        }

        function listUsageStatus() {
            return [
                { Name: 'step2_owner', Id: 10 },
                { Name: 'step2_with_tenant', Id: 20 },
                { Name: 'step2_empty', Id: 30 }
            ];
        }

        function listStructureCondition() {
            return [
                { Name: 'step2_renovated', Id: 10 },
                { Name: 'step2_standard', Id: 20 },
                { Name: 'step2_needs_renovation', Id: 30 }
            ];
        }

        function listManzaraArsa() {
            return [
                { Name: 'Şehir', Id: 50 },
                { Name: 'Doğa', Id: 60 },
                { Name: 'Göl', Id: 70 },
                { Name: 'Deniz', Id: 80 },
                { Name: 'Boğaz', Id: 90 }
            ];
        }

        function listManzaraTicari() {
            return [
                { Name: 'Bahçe', Id: 40 },
                { Name: 'Şehir', Id: 50 },
                { Name: 'Doğa', Id: 60 },
                { Name: 'Göl', Id: 70 },
                { Name: 'Deniz', Id: 80 },
                { Name: 'Boğaz', Id: 90 }
            ];
        }

        function listOlanakArsa() {
            return [
                { Name: 'Elektrik', Id: 170 },
                { Name: 'Su', Id: 175 },
                { Name: 'Yolu Açık', Id: 180 },
                { Name: 'Köşe Parsel', Id: 185 },
                { Name: 'İfraz Görmüş', Id: 190 },
                { Name: 'Denize Sıfır', Id: 195 },
                { Name: 'Denize Yakın', Id: 200 }
            ];
        }


        function listOlanakTarla() {
            return [
                { Name: 'Elektrik', Id: 170 },
                { Name: 'Su', Id: 175 },
                { Name: 'Yolu Açık', Id: 180 },
                { Name: 'Doğalgaz', Id: 210 },
                { Name: 'Telefon', Id: 220 },
                { Name: 'Kanalizasyon', Id: 230 },
                { Name: 'Zemin Etüdü', Id: 240 },
                { Name: 'Yola Yakın', Id: 250 },
                { Name: 'Denize Sıfır', Id: 195 },
                { Name: 'Denize Yakın', Id: 200 }
            ];
        }

        function listOlanakTicari() {
            return [
                { Name: 'Anayol Üzeri', Id: 10 },
                { Name: 'Cadde Üzeri', Id: 15 },
                { Name: 'Site İçerisinde', Id: 20 },
                { Name: 'Asansör', Id: 50 },
                { Name: 'Hidrofor', Id: 280 },
                { Name: 'Jeneratör', Id: 60 },
                { Name: 'Su Deposu', Id: 290 },
                { Name: 'Telefon Hattı', Id: 220 },
                { Name: 'Hırsız Alarmı', Id: 300 },
                { Name: 'Açık Otopark', Id: 90 },
                { Name: 'Yangın Alarmı', Id: 310 },
                { Name: 'Güvenlik', Id: 80 },
                { Name: 'İnternet Altyapısı', Id: 320 },
                { Name: 'Yangın Merdiveni', Id: 330 },
                { Name: 'Güvenlik Kamerası', Id: 340 },
                { Name: 'TV-Uydu Altyapısı', Id: 350 },
                { Name: 'Kapalı Otopark', Id: 100 },
                { Name: 'Köşe Parselde Konumlu', Id: 185 },
                { Name: 'Isı Yalıtımı', Id: 130 },
                { Name: 'Tır Manevra Alanı', Id: 380 },
                { Name: 'Endüstriyel Sarmal Kapı', Id: 390 },
                { Name: 'Yangın Söndürme', Id: 400 },
                { Name: 'Yükleme Rampası', Id: 410 }
            ];
        }

        function listReklamTicari() {
            return [
                { Name: 'Tabela Caddeden/Bulvardan Görülebilir', Id: 10, isActive: true },
                { Name: 'Tabela Sokaktan Görülebilir', Id: 20, isActive: true },
                { Name: 'Tabela Görülemez ya da Tabela İzni Yok', Id: 30, isActive: true }
            ];
        }

        function listSea() {
            return [
                { Name: 'Denizle İlişkisi Yok', Id: 30 },
                { Name: 'Denize Yakın', Id: 20 },
                { Name: 'Denize Sıfır', Id: 10 },
            ];
        }

        function listRoad() {
            return [
                { Name: 'Sokak Üzerinde', Id: 10 },
                { Name: 'Cadde Üzerinde', Id: 20 },
                { Name: 'Anayol Üzerinde', Id: 30 }
            ];
        }



        function listCephe() {
            return [
                { Name: 'Kuzey', Id: 10 },
                { Name: 'Güney', Id: 20 },
                { Name: 'Doğu', Id: 30 },
                { Name: 'Batı', Id: 40 }
            ];
        }

        function listTasinmazTipi() {
            return [
                { Name: 'Apartman', Id: 10 },
                { Name: 'Müstakil', Id: 20 }
            ];
        }

        function listAraziTipi() {
            return [
                { Name: 'Tarla', Id: 230 },
                { Name: 'Bağ, Bahçe', Id: 235 },
                { Name: 'zeytinlik', Id: 225 }
            ];
        }


        function listArsaTipi() {
            return [
                { Name: 'Konut', Id: 210 },
                { Name: 'Konut + Ticari', Id: 220 },
                { Name: 'Villa Parseli', Id: 280 },
                { Name: 'zoned_land_village', Id: 290 },
                { Name: 'ticari_imarli', Id: 240 }
            ];
        }


        function listDaireTipi() {
            return [
                { Name: 'Daire', Id: 10, Type: 'Apartment' },
                { Name: 'Teras Dubleks', Id: 20, Type: 'Apartment' },
                { Name: 'Ara Kat Dubleks', Id: 30, Type: 'Apartment' },
                { Name: 'Bahçe Dubleks', Id: 40, Type: 'Apartment' },
                { Name: 'Ters Dubleks', Id: 50, Type: 'Apartment' },
                { Name: 'Penthouse', Id: 60, Type: 'Apartment' },
                { Name: 'Studio Daire', Id: 70, Type: 'Apartment' },
                { Name: 'Dubleks', Id: 80, Type: 'Apartment' },
                { Name: 'Müstakil Ev', Id: 90, Type: 'House' },
                { Name: 'Kır Evi', Id: 100, Type: 'House' },
                { Name: 'Yarı Müstakil Ev', Id: 110, Type: 'House' },
                { Name: 'Teraslı Ev', Id: 120, Type: 'House' },
                { Name: 'Köy Evi', Id: 130, Type: 'House' },
                { Name: 'Emlak', Id: 140, Type: 'House' }
            ];
        }


        function listTicariTipiLight() {
            return [
                { Name: 'Dükkan/Mağaza', Id: 340 },
                { Name: 'Ofis/Büro', Id: 310 },
                { Name: 'Atölye/Depo/İmalathane', Id: 400 },
                { Name: 'Ticari Bina', Id: 390 }
            ];
        }


        function listTicariTipi() {
            return [
                { Name: 'Dükkan/Mağaza', Id: 340 },
                { Name: 'Ofis/Büro', Id: 310 },
                { Name: 'Atölye/Depo/İmalathane', Id: 400 },
                { Name: 'Ticari Bina', Id: 390 },
                { Name: 'Endüstriyel', Id: 370 },
                { Name: 'Tesisler ve Kompleksler', Id: 380 },
                { Name: 'Tesisler', Id: 380 }
            ];
        }

        function listTicariTipiSelectionTemp() {
            return [
                { Name: 'Dükkan/Mağaza', Id: 340 },
                { Name: 'Ofis/Büro', Id: 310 },
                { Name: 'Depo/Antrepo', Id: 410 },
                // { Name: 'Atölye/Depo/İmalathane', Id: 400 },
                // { Name: 'Ticari Bina', Id: 390 },
                // { Name: 'Endüstriyel', Id: 370 },
                // { Name: 'Tesisler ve Kompleksler', Id: 380 },
                // { Name: 'Tesisler', Id: 380 }
            ];
        }

        function listAltTipi() {
            return [
                { Name: 'Bağımsız Bölüm', Id: 10 },
                { Name: 'Müstakil', Id: 20 }
            ];
        }

        function listTicariKonumTipi() {
            return [
                { Name: 'Sanayi Bölgesi veya Sitesi İçerisinde Değil', Id: 10 },
                { Name: 'Organize Sanayi Bölgesi (OSB) İçerisinde', Id: 20 },
                { Name: 'Küçük Sanayi Sitesi (KSS) İçerisinde', Id: 30 }
            ];
        }
        function listTicariKotFarkiTipi() {
            return [
                { Name: 'Cadde/Sokak seviyesinde/üzerinde', Id: 10 },
                { Name: 'Cadde/Sokak seviyesi altında', Id: 20 },
                { Name: 'İş Hanı/pasaj İçerisinde', Id: 30 }
            ];
        }

        function listKatTipi() {
            return [
                { Name: 'Tek Katlı', Id: 10 },
                { Name: 'Çok Katlı', Id: 20 }
            ];
        }

        function listYapininDurumu() {
            return [
                { Name: 'step3_helpers_brandNew', Id: 40 },
                { Name: 'step3_helpers_used', Id: 50 }
            ];
        }


        function listTicariOfisTipi() {
            return [
                { Name: 'Plaza/İşhanı Ofis/Büro', Id: 120, isActive: true },
                { Name: 'İş Hanında', Id: 20, isActive: false },
                { Name: 'Apartman Dairesi Ofis/Büro', Id: 130, isActive: true },
                { Name: 'Müstakil Ofis/Büro', Id: 140, isActive: true },
                { Name: 'Konut Bulunan Binada', Id: 120, isActive: false }
            ];
        }


        function listTicariBinaTipi() {
            return [
                { Name: 'Plaza', Id: 10 },
                { Name: 'İş Hanı', Id: 20 },
                { Name: 'AVM', Id: 30 }
            ];
        }

        function listeEndustriTipi() {
            return [
                { Name: 'Fabrika ve Arsası ', Id: 50 },
                { Name: 'Üretim Kompleksi', Id: 60 }
            ];
        }


        function listEgim() {
            return [
                { Name: 'Düz Arazi (%0-3)', Id: 1 },
                { Name: 'Az Eğimli (%4-15)', Id: 2 },
                { Name: 'Eğimli (%15+)', Id: 3 }
            ];
        }

        function listUrun() {
            return [
                { Name: 'Tahıl', Id: 100 },
                { Name: 'Baklagil', Id: 200 },
                { Name: 'Yağ/Lif/Nişasta/Şeker', Id: 300 },
                { Name: 'Tıbbi/Aromatik', Id: 400 },
                { Name: 'Sebze', Id: 500 },
                { Name: 'Nadas', Id: 600 }
            ];
        }

        function listIsinmaDurumu() {
            return [
                { Name: 'Yok', Id: 10 },
                { Name: 'Soba', Id: 20 },
                { Name: 'Doğalgaz Sobası', Id: 30 },
                { Name: 'Kat Kaloriferi', Id: 40 },
                { Name: 'Doğalgaz/Kombi', Id: 50 },
                { Name: 'Merkezi Sistem', Id: 60 },
                { Name: 'Merkezi Isı Pay Ölçer', Id: 70 },
                { Name: 'Yerden Isıtma', Id: 80 },
                { Name: 'Klima Sistemi', Id: 90 },
                { Name: 'Jeotermal Isınma', Id: 100 },
                { Name: 'Güneş Enerjisi', Id: 110 },
                { Name: 'VRF', Id: 130 },
                { Name: 'FanCoil', Id: 140 },
                { Name: 'Akaryakıt', Id: 150 },
                { Name: 'Elektrik', Id: 160 },
                { Name: 'Propan/Butan Gazı', Id: 170 },
                { Name: 'Diğer', Id: 120 }
            ];
        }

        function listIsinmaDurumuTicari() {
            return [
                { Name: 'Yok', Id: 10 },
                { Name: 'Soba', Id: 20 },
                { Name: 'Doğalgaz Sobası', Id: 30 },
                { Name: 'Kat Kaloriferi', Id: 40 },
                { Name: 'Doğalgaz/Kombi', Id: 50 },
                { Name: 'Merkezi Sistem', Id: 60 },
                { Name: 'Merkezi Isı Pay Ölçer', Id: 70 },
                { Name: 'Yerden Isıtma', Id: 80 },
                { Name: 'Klima Sistemi', Id: 90 },
                { Name: 'Jeotermal Isınma', Id: 100 },
                { Name: 'Güneş Enerjisi', Id: 110 },
                { Name: 'VRF (VRV)', Id: 130 },
                { Name: 'Fan-coil', Id: 140 },
                { Name: 'Diğer', Id: 120 }
            ];
        }

        function resolveAddress(address) {
            var lat, lon, latLon;
            var deferred = $q.defer();
            if (!address) {
                deferred.resolve(null);
            } else if (address.indexOf('%252C') > -1) {
                latLon = address.split('%253B35%252C');
                lat = parseFloat(latLon[0].replace("%252C", "."));
                lon = parseFloat(latLon[1].replace("%252C", "."));
                deferred.resolve({
                    lat: lat,
                    lon: lon
                });
            } else if (address.indexOf(';') > -1) {
                latLon = address.split(';');
                lat = parseFloat(latLon[0].replace(",", "."));
                lon = parseFloat(latLon[1].replace(",", "."));
                deferred.resolve({
                    lat: lat,
                    lon: lon
                });
                //process(lat, lon);
            }
            //typeahead zaten lokasyonu almış
            else if (window.selectedLocation) {
                lat = +window.selectedLocation.split(' ')[1];
                lon = +window.selectedLocation.split(' ')[0];
                window.selectedLocation = null;
                deferred.resolve({
                    lat: lat,
                    lon: lon
                });
            } else {
                address = address.replaceAllString('-', ' ');
                yandexGeocode.geocodeAddress(address)
                    .then(function (latlng) {
                        lat = latlng.lat();
                        lon = latlng.lng();
                        deferred.resolve({
                            lat: lat,
                            lon: lon
                        });
                        //process(lat, lon);
                    }, function (reject) {
                        notifierSvc.show({ message: reject.data, type: "error" });
                        deferred.reject({
                            lat: 39,
                            lng: 10,
                            zoom: 3
                        });

                    });
            }
            return deferred.promise;
        }

        function setDetailMarker(lat, lng, address) {
            return mapOptionsService.getMarker(parseFloat(lat), parseFloat(lng), address);
        }

        function fetchData(detailName, list) {
            var array = [];
            var arrayDiff = [];
            detailName.forEach(function (name) {
                list.forEach(function (item) {
                    if (item.Id === name.Olanak || item.Id === name.Manzara || item.Id === name.BinaGirisCephesi) {
                        array.push(item);
                    }
                });
            });

            arrayDiff = list.diff(array);
            arrayDiff.forEach(function (itemDiff) {
                itemDiff.selected = false;
            });
            array.forEach(function (item) {
                item.selected = true;
            });
            array = arrayDiff.concat(array);

            return array;
        }

        function toggleInfo() {

            $('.ed-input-info').slidePanel({
                useCssTransforms3d: true,
                useCssTransforms: true,
                useCssTransitions: true,
                mouseDrag: false,
                touchDrag: false,
                pointerDrag: false,
                //closeSelector: '.slidePanel-close',
                contentFilter(content, object) {
                    return $compile(content)($rootScope);
                },
                afterLoad: function () {
                    this.$panel.find('.' + this.options.classes.base).asScrollable({
                        namespace: 'scrollable',
                        contentSelector: '>',
                        containerSelector: '>'

                    });
                },

                afterShow: function () {
                    setTimeout(function () {
                        $(".slidePanel-close").on("click", function () {
                            $.slidePanel.hide();
                        });
                    }, 300);
                }
            });
        }
    }
})();
